import CompleteProfilePage from './CompleteProfilePage';
export default CompleteProfilePage;
